import { connect } from 'react-redux';
import ViolationData from './ViolationData';
import { getUpdateViolationLoader } from '../../../../store/selectors/violation.selectors';
import { updateViolationBegin } from '../../../../store/actions/violation.actions';
import { setError } from '../../../../store/actions/site.actions';

const mapStateToProps = (state: any) => {
    const isLoading = getUpdateViolationLoader(state);
    return { isLoading };
};

const mapDispatchToProps = {
    updateViolation: updateViolationBegin,
    setError: setError,
};
export default connect(mapStateToProps, mapDispatchToProps)(ViolationData);
